export default __webpack_public_path__ + "static/media/desactivate_icon.e5144e65.svg";